module.exports = __webpack_public_path__ + "img/warm_coffee.a5fb7f36.png";